import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class SurveyRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/survey/survey-routing.module.ts